import { h, Component } from "preact";
import { css } from "emotion";
import { debounce } from "throttle-debounce";

import InputWrapper from "./InputWraper";

const inputStyle = css({
  appearance: "none",
  width: "100%",
  height: 40,
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#8D949E",
  backgroundColor: "#f9f9fa",
  fontSize: 16,
  paddingLeft: 12,
  "@media(max-width: 600px)": {
    width: "100%",
    height: 36,
    fontSize: 14,
    paddingLeft: 12
  }
});

const dropDownWrapper = css({
  position: "absolute",
  width: 0,
  height: 0,
  zIndex: 999999
});

const dropDownItem = css({
  position: "relative",
  overflow: "hidden",
  background: "white",
  width: 402,
  minHeight: 40,
  margin: 0,
  border: "1px solid #8D949E",
  padding: "8px 12px",
  borderRadius: 4,
  fontWeight: 700,
  cursor: "pointer"
});

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      result: null
    };
    this.updateSearchTerm = this.updateSearchTerm.bind(this);
    this.selectOption = this.selectOption.bind(this);
  }

  updateSearchTerm(e) {
    const { input } = this.props;
    input.onChange(null);
    this.setState({
      searchTerm: e.target.value,
      result: null
    });
  }

  selectOption(option) {
    const { labelKey } = this.props;
    this.setState({
      searchTerm: option[labelKey],
      result: option
    });
  }

  render() {
    const {
      name,
      type,
      placeholder,
      label,
      input,
      meta: { touched, error },
      searchFunction,
      options,
      labelKey,
      valueKey,
      blurFunction
    } = this.props;
    const { searchTerm, result } = this.state;
    const customError = result === null ? "This field is required" : null;
    return (
      <div style={{ position: "relative" }}>
        <InputWrapper touched={touched} error={customError} label={label}>
          <input
            placeholder={placeholder}
            className={inputStyle}
            onKeyUp={debounce(500, false, e => {
              searchFunction(e);
              this.updateSearchTerm(e);
            })}
            onBlur={debounce(500, false, () => {
              blurFunction();
              input.onBlur();
            })}
            value={searchTerm}
            data-cy={`custom search`}
          />
          <div className={dropDownWrapper}>
            {options.map((option, index) => (
              <div
                className={dropDownItem}
                onClick={() => {
                  input.onChange(option);
                  this.selectOption(option);
                }}
                data-cy={`option${index} custom search`}
              >
                {option[labelKey]}
              </div>
            ))}
          </div>
        </InputWrapper>
      </div>
    );
  }
}

export default SearchField;
